import type { CSS } from '../../stitches.config';
import type { SpacingScale } from './sizes';

export const spacingCSS = (spacing?: SpacingScale): CSS =>
  spacing != null
    ? {
        gap: `$${spacing}`,
      }
    : {};

export const spacingRowCSS = (spacing?: SpacingScale): CSS =>
  spacing != null
    ? {
        rowGap: `$${spacing}`,
      }
    : {};

export const spacingColumnCSS = (spacing?: SpacingScale): CSS =>
  spacing != null
    ? {
        columnGap: `$${spacing}`,
      }
    : {};
